export default "__VITE_ASSET__BhKOXGHR__"